module.exports = __webpack_public_path__ + "48a8ea3ac1925068ccecae3287938f33.fbx";